import $ from 'jquery'


export const readUTMFromURL = () => {
    const queryParams = new URLSearchParams(window.location.search)
    const source = queryParams.get("utm_source")
    const campaign = queryParams.get("utm_campaign")
    const medium = queryParams.get("utm_medium")
    const content = queryParams.get("utm_content")
    const term = queryParams.get("utm_term")
    if (source) {
        window.sessionStorage.setItem("utm_source", source);
    }
    if (campaign) {
        window.sessionStorage.setItem("utm_campaign", campaign);
    }
    if (medium) {
        window.sessionStorage.setItem("utm_medium", medium);
    }
    if (content) {
        window.sessionStorage.setItem("utm_content", content);
    }
    if (term) {
        window.sessionStorage.setItem("utm_term", term);
    }
}

export const setUTMToHubspotForm = ()=> {
    const source =  window.sessionStorage.getItem("utm_source");
    const campaign =  window.sessionStorage.getItem("utm_campaign");
    const term =  window.sessionStorage.getItem("utm_term");
    const medium =  window.sessionStorage.getItem("utm_medium");
    const content =  window.sessionStorage.getItem("utm_content");
    $('input[name="utm_source"]').val(source).change(); 
    $('input[name="utm_campaign"]').val(campaign).change(); 
    $('input[name="utm_term"]').val(term).change(); 
    $('input[name="utm_medium"]').val(medium).change(); 
    $('input[name="utm_content"]').val(content).change(); 
  }

